import {Injectable} from '@angular/core';
import {from, Observable} from 'rxjs';
import {findUniqueMatchWithId, readDocumentWithId} from '../common/firestore-utils';
import {TenantService} from './tenant.service';
import {first, map} from 'rxjs/operators';
import {Course} from '../models/course.model';
import {Update} from '@ngrx/entity';
import {CourseSection} from '../models/course-section.model';
import {collection, collectionData, deleteDoc, doc, docData, Firestore, orderBy, query, setDoc, updateDoc, where, writeBatch} from '@angular/fire/firestore';
import {QueryConstraint} from '@firebase/firestore';


@Injectable()
export class CoursesDBService {

  constructor(
    private tenant: TenantService,
    private firestore: Firestore) {

  }

  findCourseByUrl(courseUrl: string) {

    const constraints: QueryConstraint[] = [
      where('url', '==', courseUrl)
    ]

    const courseQuery = query(
      collection(this.firestore, this.coursesPath),
      ...constraints
    )

    const courseSnap = collectionData(courseQuery) 

    return findUniqueMatchWithId(courseSnap).pipe(first()) as Observable<Course>;

  }

  findCourseBySeqNo(seqNo: number) {

    const constraints: QueryConstraint[] = [
      where('seqNo', '==', seqNo)
    ]

    const courseQuery = query(
      collection(this.firestore, this.coursesPath),
      ...constraints
    )

    const courseSnap = collectionData(courseQuery) 

    return findUniqueMatchWithId(courseSnap).pipe(first()) as Observable<Course>;

  }

  suscribeToCourse(courseId: string): Observable<Course> {
    const courseDocRef = doc(this.firestore,this.coursesPath + '/' + courseId)
    const cousreDocData = docData(courseDocRef, {
      idField: 'id'
    })
    
    return readDocumentWithId(cousreDocData)

    // return readDocumentWithId(this.afs.doc(this.coursesPath + '/' + courseId));
  }

  findAllCourses(includeDraftCourses: boolean = true): Observable<Course[]> {

    const constraints: QueryConstraint[] = [
      orderBy('seqNo')
    ];

    if (!includeDraftCourses) {
      constraints.push(where('status', '==', 'published'))
    }

    const q = query(
      collection(this.firestore, this.coursesPath),
      ...constraints
    )

    const courseSnap = collectionData(q, {idField: 'id'});

    return courseSnap.pipe(first()) as Observable<Course[]>;
  }

  createNewCourse(course: Course): Observable<null> {
    const docRef = doc(this.firestore,`${this.coursesPath}/${course.id}`)
    return from(setDoc(docRef, course)) as Observable<null>;
  }

  findNextCourseSeqNo() {
    return this.findAllCourses()
      .pipe(
        map(courses => {

          if (courses?.length === 0) {
            return 1;
          }

          const allSeqNos = courses?.map((course) => course.seqNo);

          const maxSeqNo = Math.max(...allSeqNos) || 0;

          return (maxSeqNo + 1);
        })
      )
  }

  deleteCourseDraft(courseId: string): Observable<any> {
    return from(deleteDoc(doc(this.firestore,`${this.coursesPath}/${courseId}`)))
  }

  saveCourse(courseId: any, props: Partial<Course>): Observable<any> {
    const docRef = doc(this.firestore,`${this.coursesPath}/${courseId}`)
    return from(updateDoc(docRef, props))
  }

  private get coursesPath() {
    return this.tenant.path('courses');
  }

  updateCourses(changes: Update<Course>[]) {

    const batch = writeBatch(this.firestore)

    changes.forEach(change => {
      const courseRef = doc(this.firestore,`schools/${this.tenant.id}/courses/${change.id}`);
      batch.update(courseRef, change.changes);
    });

    return from(batch.commit());

  }

  updateCourseSections(courseId: string, changes: Update<CourseSection>[]) {

    const batch = writeBatch(this.firestore)

    changes.forEach(change => {
      const courseRef = doc(this.firestore, `schools/${this.tenant.id}/courses/${courseId}/sections/${change.id}`);
      batch.update(courseRef, change.changes);
    });

    return from(batch.commit());

  }

  findCourseByTenantAndId(tenantId: string, courseId: string) {
    const courseRef = doc(this.firestore,`schools/${tenantId}/courses/${courseId}`)

    return readDocumentWithId<Course>(docData(courseRef, { idField: 'id' })).pipe(first());
  }
}




